import React from "react";

const LoadingSpinner: React.FC = () => (
  <span className="loading-spinner">
    <span className="fa fa-spinner fa-spin" aria-hidden="true"></span>
  </span>
);

export default LoadingSpinner;
